// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OverlayTrigger {
  background: #FFF;
  color: #002E33;
  width: auto;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  padding: 5px;
}
.OverlayTrigger__arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
}
[data-placement^=top] .OverlayTrigger__arrow {
  border-width: 5px 5px 0 5px;
  border-color: #FFF transparent transparent transparent;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
[data-placement^=bottom] .OverlayTrigger__arrow {
  border-width: 0 5px 5px 5px;
  border-color: transparent transparent #FFF transparent;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
[data-placement^=right] .OverlayTrigger__arrow {
  border-width: 5px 5px 5px 0;
  border-color: transparent #FFF transparent transparent;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
[data-placement^=left] .OverlayTrigger__arrow {
  border-width: 5px 0 5px 5px;
  border-color: transparent transparent transparent #FFF;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.OverlayTrigger[data-placement^=top] {
  margin-bottom: 5px;
}
.OverlayTrigger[data-placement^=bottom] {
  margin-top: 5px;
}
.OverlayTrigger[data-placement^=right] {
  margin-left: 5px;
}
.OverlayTrigger[data-placement^=left] {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/OverlayTrigger/OverlayTrigger.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAAA;EAGE,gBCKM;EDJN,cCFa;EDGb,WAAA;EACA,wDAAA;UAAA,gDAAA;EACA,YAAA;AADF;AAGE;EACE,QAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAZM;AAWV;AAEI;EACE,2BAAA;EACA,sDAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AAAN;AAEI;EACE,2BAAA;EACA,sDAAA;EACA,SAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AAAN;AAEI;EACE,2BAAA;EACA,sDAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;AAAN;AAEI;EACE,2BAAA;EACA,sDAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;AAAN;AAIE;EACE,kBAAA;AAFJ;AAIE;EACE,eAAA;AAFJ;AAIE;EACE,gBAAA;AAFJ;AAIE;EACE,iBAAA;AAFJ","sourcesContent":[".OverlayTrigger {\n  @import  \"../../../Global/Colors.scss\";\n  $margin:5px;\n  background: $White;\n  color: $DeepSeaGreen;\n  width: auto;\n  box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n  padding: 5px;\n\n  &__arrow {\n    width: 0;\n    height: 0;\n    border-style: solid;\n    position: absolute;\n    margin: $margin;\n    [data-placement^=\"top\"] & {\n      border-width: 5px 5px 0 5px;\n      border-color: $White transparent transparent transparent;\n      bottom: -$margin;\n      left: calc(50% - 5px);\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n    [data-placement^=\"bottom\"] & {\n      border-width: 0 5px 5px 5px;\n      border-color: transparent transparent $White transparent;\n      top: -$margin;\n      left: calc(50% - 5px);\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n    [data-placement^=\"right\"] & {\n      border-width: 5px 5px 5px 0;\n      border-color: transparent $White transparent transparent;\n      left: -$margin;\n      top: calc(50% - 5px);\n      margin-left: 0;\n      margin-right: 0;\n    }\n    [data-placement^=\"left\"] & {\n      border-width: 5px 0 5px 5px;\n      border-color: transparent transparent transparent $White;\n      right: -$margin;\n      top: calc(50% - 5px);\n      margin-left: 0;\n      margin-right: 0;\n    }\n  }\n\n  &[data-placement^=\"top\"] {\n    margin-bottom: 5px;\n  }\n  &[data-placement^=\"bottom\"] {\n    margin-top: 5px;\n  }\n  &[data-placement^=\"right\"] {\n    margin-left: 5px;\n  }\n  &[data-placement^=\"left\"] {\n    margin-right: 5px;\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
